<ng-template #modalLG let-modal>
    <div class="modal-content paiement-modal-content" style="width: 1232px; max-width: 1132px; min-width: 500px; margin: 1.75rem auto; transform: translateY(-50%); position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); max-height: 90vh; display: flex; flex-direction: column;">
        <div class="modal-header paiement-modal-header" style="background-color: transparent; border-bottom: none; flex-shrink: 0;">
            <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        
        <!-- Section fixe en haut -->
        <div class="paiement-modal-top-section" style="flex-shrink: 0;">
            <div class="text-center" style="padding: 30px 0 0 0;">
                <p class="title-modal" id="fileUploadModalLabel">Paiement facture</p>
                <p class="text-modal">
                    Gérez vos paiements
                </p>
            </div>

            <div style="margin: 24px 64px">
                <table class="table table-hover">
                    <thead class="align-middle custom-header">
                    <tr class="text-start">
                        <th>DATE</th>
                        <th>RÉFÉRENCE</th>
                        <th>RESPONSABLE</th>
                        <th>MONTANT</th>
                        <th class="uppercase">RESTE à PAYER</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr class="ligne text-start" *ngIf="selectedFacture">
                        <td class="padd" style="width: 15%">{{ selectedFacture.date | date: 'dd/MM/yyyy' }}</td>
                        <td class="titre1 padd"><a href="#" class="ref">{{ selectedFacture.reference }}</a></td>
                        <td class="titre3 padd">{{ getPartyName(selectedFacture) }}</td>
                        <td class="titre3 padd">{{ getMontantFacture(selectedFacture) }}</td>
                        <td class="titre3 padd">{{ (activeTab === 'nouveau-paiement' && resteAPayerFromChild !== null ? resteAPayerFromChild : resteAPayer) | number:'1.2-2' }} TND</td>
                    </tr>
                    <tr *ngIf="!selectedFacture">
                        <td colspan="5" class="text-center">Aucune facture sélectionnée</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- Section scrollable -->
        <div class="paiement-modal-body" style="overflow-y: auto; overflow-x: hidden; flex: 1; min-height: 0;">
            <div style="margin: 0 64px">

                <!-- Tabs -->
                <ul class="nav nav-tabs" style="border-bottom: 1px solid #eee; margin-bottom: 24px;">
                    <li class="nav-item">
                        <a class="nav-link" [ngClass]="{'active': activeTab === 'nouveau-paiement'}" (click)="setActiveTab('nouveau-paiement')" style="padding-left: 20px">
                            Nouveau paiement
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" [ngClass]="{'active': activeTab === 'paiement-non-affectes'}" (click)="setActiveTab('paiement-non-affectes')" style="padding-left: 20px">
                            Paiements non affectés
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" [ngClass]="{'active': activeTab === 'depuis-un-avoir'}" (click)="setActiveTab('depuis-un-avoir')" style="padding-left: 20px">
                            Depuis un avoir
                        </a>
                    </li>
                </ul>

                <!-- Tab Content -->
                <div class="tab-content" >
                    <ng-container *ngIf="activeTab === 'nouveau-paiement'">
                        <app-nouveau-paiement
                            #nouveauPaiement
                            [documentId]="selectedFacture?.id"
                            [factureIdForAvoir]="getDocumentOriginalId(selectedFacture)"
                            [clientId]="getClientId(selectedFacture)"
                            [fournisseurId]="getFournisseurId(selectedFacture)"
                            [documentRefExterne]="selectedFacture?.ref_externe"
                            [montantTotal]="factureMontant"
                            [timbreFiscal]="factureTimbreFiscal"
                            [documentType]="selectedDocumentType"
                            [documentStatut]="getDocumentStatut(selectedFacture)"
                            [documentStatutId]="getDocumentStatutId(selectedFacture)"
                            [triggerCreate]="triggerCreatePaiement"
                            [resteAPayer]="resteAPayer"
                            [avoirSelectionne]="selectedAvoir"
                            (paiementCreated)="onPaiementCreated($event)"
                            (resteAPayerCalcule)="onResteAPayerCalcule($event)">
                        </app-nouveau-paiement>
                    </ng-container>
                    <ng-container *ngIf="activeTab === 'paiement-non-affectes'">
                        <app-paiement-non-aff 
                            #paiementNonAff 
                            [documentId]="selectedFacture?.id"
                            [clientId]="getClientId(selectedFacture)"
                            [stationId]="getStationId()">
                        </app-paiement-non-aff>
                    </ng-container>
                    <ng-container *ngIf="activeTab === 'depuis-un-avoir'">
                        <app-depuis-avoir
                            [facture]="selectedFacture"
                            [documentType]="selectedDocumentType"
                            [stationId]="getStationId()"
                            [refreshTrigger]="refreshAvoirsTrigger"
                            (utiliserAvoirClick)="onUtiliserAvoir($event)"
                            (ajouterPaiementAvoirClick)="onAjouterPaiementAvoir($event)">
                        </app-depuis-avoir>
                    </ng-container>
                </div>
            </div>
        </div>

        <!-- Footer fixe en bas -->
        <div class="modal-footer p-0 paiement-modal-footer" style="justify-content: center; gap: 16px; border-top: none; flex-shrink: 0; padding: 16px 0 24px 0 !important;">
                <button
                        type="button"
                        class="btn d-flex align-items-center justify-content-center"
                        style="padding: 8px 16px; font-size: 14px; background-color: rgba(128, 131, 144, 0.16);"
                        (click)="modal.dismiss('Cancel click')"
                >
                    Fermer
                </button>
                <button
                        type="button"
                        class="btn btn-primary d-flex align-items-center justify-content-center"
                        style="padding: 8px 16px; font-size: 14px;"
                        (click)="convertDocument()"
                >
                    Soumettre et télécharger
                </button>
                <button
                        type="button"
                        class="btn btn-primary d-flex align-items-center justify-content-center"
                        style="padding: 8px 16px; font-size: 14px;"
                        (click)="validatePaiement()"
                >
                    Valider
                </button>
        </div>
    </div>
</ng-template>
